<template>
  <div class="custom-fields-table" data-testid="setup-tasklist__custom-fields-table">
    <v-skeleton-loader
      v-if="loading"
      type="table-heading, table-row-divider@8"
      class="custom-fields-table__skeleton"
      data-testid="setup-tasklist__custom-fields-skeleton"
    />

    <lb-datatableaction
      v-else
      :headers="headers"
      :tabledata="rows"
      :displayed-row-count="rows.length"
      :itemsperpage="itemsPerPage"
      :bulk-actions="false"
      data-testid="setup-tasklist__custom-fields-datatable"
      header-bg-class="fbc-table-header-bg"
    >
      <template #tbody>
        <tr
          v-for="(item, index) in rows"
          :key="item._id || `system-${index}`"
          class="custom-fields-table__row"
          :class="{ 'custom-fields-table__row--system': item.isSystem }"
          data-testid="setup-tasklist__custom-field-row"
        >
          <template v-for="header in headers">
            <td
              v-if="header.visible && header.value === 'ingestionType'"
              :key="`${header.value}-${index}-ingestion`"
              class="px-4 single-line"
            >
              <span
                class="custom-fields-table__ingestion-badge"
                :class="{ 'custom-fields-table__ingestion-badge--system': item.isSystem }"
              >
                {{ item.ingestionType }}
              </span>
            </td>

            <td
              v-else-if="header.visible && header.value === 'action'"
              :key="`${header.value}-${index}-action`"
              class="px-4 single-line action-data"
            >
              <v-btn
                v-if="!item.isSystem"
                icon
                small
                data-testid="setup-tasklist__custom-field-edit-btn"
                @click="$emit('edit', item)"
              >
                <v-icon small>mdi-pencil-outline</v-icon>
              </v-btn>
            </td>

            <td
              v-else-if="header.visible"
              :key="`${header.value}-${index}-value`"
              class="px-4 single-line"
            >
              {{ item[header.value] || '—' }}
            </td>
          </template>
        </tr>
      </template>
    </lb-datatableaction>
  </div>
</template>

<script>
import './CustomFieldsTable.scss';

export default {
  name: 'CustomFieldsTable',

  props: {
    rows: {
      type: Array,
      default: () => [],
    },
    headers: {
      type: Array,
      default: () => [],
    },
    itemsPerPage: {
      type: Number,
      default: 25,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
